import { HelpResourcesRoutesEnum } from './routes.enum';

export const resourcesTabs = [
  {
    label: 'Contact us ',
    value: HelpResourcesRoutesEnum.ContactUs,
  },
  {
    label: 'Information links',
    value: HelpResourcesRoutesEnum.InformationLinks,
  },
  {
    label: 'Feedback',
    value: HelpResourcesRoutesEnum.Feedback,
  },
];
